import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './hooks/useAuth';

const ProtectedRoute = ({ element: Element, requiredPermission }) => {
  const { canActivate } = useAuth();

  const hasPermission = canActivate(requiredPermission)

  return hasPermission ? <Element /> : <Navigate to="/home" replace />;
};

export default ProtectedRoute;